export var Plans;
(function (Plans) {
    Plans["freeStarter"] = "free_starter";
    Plans["proMsme"] = "pro_msme";
    Plans["proStarter"] = "pro_starter";
    Plans["proBronze"] = "pro_bronze";
    Plans["proSilver"] = "pro_silver";
    Plans["proGold"] = "pro_gold";
    Plans["proPlatinum"] = "pro_platinum";
    Plans["proDiamond"] = "pro_diamond";
    Plans["proMythical"] = "pro_mythical";
    Plans["proPremium"] = "pro_premium";
})(Plans || (Plans = {}));
